module.exports = __webpack_public_path__ + "static/media/logos.ddf5509e.png";